import React from "react";
import Header from "../header/Header";
import MainMenu from "./MainMenu";
import s from './main.module.css'
import {APP_V} from "../../API/API";


const Main = ({exit, user, roles, isLogoutLoader}) => {
    return (
        <div>
            <Header exit={exit} user={user} isLogoutLoader={isLogoutLoader}/>
            <MainMenu roles={roles} user={user}/>
            <div className={s.ftr}>{APP_V}</div>
        </div>
    )
}

export default Main
